"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomWidget = exports.isNormalObject = exports.isQRCodeObject = exports.isPlayerVideoObject = exports.isWorkareaObjectWithImage = exports.isWorkareaObject = exports.isWeatherObject = exports.isDateObject = exports.isTableObject = exports.isRssFeedObject = exports.isStopScheduleObject = exports.isIframeObject = exports.isRectangleObject = exports.isCircleObject = exports.isTriangleObject = exports.isVideoObject = exports.isImageObject = exports.isPolygonWithCustomControlsObject = exports.isLineWithCustomControlsObject = exports.isPathObject = exports.isTextBoxObject = exports.getCustomFabricObjectProps = exports.isFabricObjectOptionsUI = exports.isFabricObjectOptionsPlayer = exports.isFabricObjectOptions = exports.CustomFabricObjectProps = exports.isFabricWidgetOptionsUI = exports.isFabricWidgetOptions = exports.isFabricWidgetOptionsPlayer = exports.isFabricWidgetPartialOptions = exports.isFabricOnlyOptions = exports.isFabricTriangleOptions = exports.isFabricTextboxOptions = exports.isFabricRectOptions = exports.isFabricPolygonOptions = exports.isFabricPathOptions = exports.isFabricLineOptions = exports.isFabricWorkareaOptions = exports.isFabricImageOptions = exports.isFabricCircleOptions = exports.FabricWidgetObjectFit = exports.ObjectType = void 0;
const date_1 = require("./date");
const iframe_1 = require("./iframe");
const mediaCarousel_1 = require("./mediaCarousel");
const qrCode_1 = require("./qrCode");
const rssFeed_1 = require("./rssFeed");
const socialMedia_1 = require("./socialMedia");
const stopSchedule_1 = require("./stopSchedule");
const table_1 = require("./table");
const video_1 = require("./video");
const weather_1 = require("./weather");
const falconyAnnouncements_1 = require("./falconyAnnouncements");
var ObjectType;
(function (ObjectType) {
    ObjectType["workarea"] = "workarea";
    ObjectType["textbox"] = "textbox";
    ObjectType["image"] = "image";
    ObjectType["video"] = "video";
    ObjectType["rect"] = "rect";
    ObjectType["circle"] = "circle";
    ObjectType["triangle"] = "triangle";
    ObjectType["line"] = "line";
    ObjectType["polygon"] = "polygon";
    ObjectType["text"] = "text";
    ObjectType["freeDrawing"] = "freeDrawing";
    ObjectType["lineWithCustomControls"] = "lineWithCustomControls";
    ObjectType["polygonWithCustomControls"] = "polygonWithCustomControls";
    ObjectType["path"] = "path";
    ObjectType["backgroundImage"] = "backgroundImage";
    ObjectType["iframe"] = "iframe";
    ObjectType["stopSchedule"] = "stopSchedule";
    ObjectType["table"] = "table";
    ObjectType["date"] = "date";
    ObjectType["weather"] = "weather";
    ObjectType["rssFeed"] = "rssFeed";
    ObjectType["mediaCarousel"] = "mediaCarousel";
    ObjectType["qrCode"] = "qrCode";
    ObjectType["socialMedia"] = "socialMedia";
    // Latest Types
    ObjectType["CustomWorkarea"] = "CustomWorkarea";
    ObjectType["CustomTextbox"] = "CustomTextbox";
    ObjectType["CustomImage"] = "CustomImage";
    ObjectType["CustomVideo"] = "CustomVideo";
    ObjectType["CustomRect"] = "CustomRect";
    ObjectType["CustomCircle"] = "CustomCircle";
    ObjectType["CustomTriangle"] = "CustomTriangle";
    ObjectType["CustomLine"] = "CustomLine";
    ObjectType["CustomPolygon"] = "CustomPolygon";
    ObjectType["CustomPath"] = "CustomPath";
    ObjectType["CustomIframe"] = "CustomIframe";
    ObjectType["CustomStopSchedule"] = "CustomStopSchedule";
    ObjectType["CustomTable"] = "CustomTable";
    ObjectType["CustomDate"] = "CustomDate";
    ObjectType["CustomWeather"] = "CustomWeather";
    ObjectType["CustomRssFeed"] = "CustomRssFeed";
    ObjectType["CustomMediaCarousel"] = "CustomMediaCarousel";
    ObjectType["CustomQRCode"] = "CustomQRCode";
    ObjectType["CustomSocialMedia"] = "CustomSocialMedia";
    ObjectType["CustomFalconyAnnouncements"] = "CustomFalconyAnnouncements";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));
var FabricWidgetObjectFit;
(function (FabricWidgetObjectFit) {
    FabricWidgetObjectFit["cover"] = "cover";
    FabricWidgetObjectFit["fill"] = "fill";
    FabricWidgetObjectFit["contain"] = "contain";
})(FabricWidgetObjectFit = exports.FabricWidgetObjectFit || (exports.FabricWidgetObjectFit = {}));
exports.isFabricCircleOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomCircle;
exports.isFabricImageOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomImage;
exports.isFabricWorkareaOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomWorkarea;
exports.isFabricLineOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomLine;
exports.isFabricPathOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomPath;
exports.isFabricPolygonOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomPolygon;
exports.isFabricRectOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomRect;
exports.isFabricTextboxOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomTextbox;
exports.isFabricTriangleOptions = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.CustomTriangle;
exports.isFabricOnlyOptions = (obj) => [
    exports.isFabricCircleOptions,
    exports.isFabricImageOptions,
    exports.isFabricLineOptions,
    exports.isFabricPathOptions,
    exports.isFabricPolygonOptions,
    exports.isFabricRectOptions,
    exports.isFabricTextboxOptions,
    exports.isFabricTriangleOptions
].some(fn => fn(obj));
exports.isFabricWidgetPartialOptions = (obj) => [
    date_1.isFabricDateOptions,
    iframe_1.isFabricIframeOptions,
    socialMedia_1.isFabricSocialMediaOptions,
    stopSchedule_1.isFabricStopScheduleOptions,
    qrCode_1.isFabricQRCodeOptions,
    rssFeed_1.isFabricRssFeedOptions,
    table_1.isFabricTableOptions,
    weather_1.isFabricWeatherOptions,
    falconyAnnouncements_1.isFabricFalconyAnnouncementsOptions
].some(fn => fn(obj));
exports.isFabricWidgetOptionsPlayer = (obj) => [
    exports.isFabricWidgetPartialOptions,
    mediaCarousel_1.isFabricMediaCarouselOptionsPlayer,
    video_1.isFabricVideoOptionsPlayer
].some(fn => fn(obj));
exports.isFabricWidgetOptions = (obj) => [exports.isFabricWidgetPartialOptions, mediaCarousel_1.isFabricMediaCarouselOptions, video_1.isFabricVideoOptions].some(fn => fn(obj));
exports.isFabricWidgetOptionsUI = (obj) => [
    exports.isFabricWidgetPartialOptions,
    mediaCarousel_1.isFabricMediaCarouselOptionsPlayer,
    video_1.isFabricVideoOptions
].some(fn => fn(obj));
var CustomFabricObjectProps;
(function (CustomFabricObjectProps) {
    CustomFabricObjectProps["cId"] = "cId";
    CustomFabricObjectProps["cKey"] = "cKey";
    CustomFabricObjectProps["cType"] = "cType";
    CustomFabricObjectProps["cVideoSrc"] = "cVideoSrc";
    CustomFabricObjectProps["cVideoAutoplay"] = "cVideoAutoplay";
    CustomFabricObjectProps["cVideoLoop"] = "cVideoLoop";
    CustomFabricObjectProps["cVideoMuted"] = "cVideoMuted";
    CustomFabricObjectProps["cVideoWidth"] = "cVideoWidth";
    CustomFabricObjectProps["cVideoHeight"] = "cVideoHeight";
    CustomFabricObjectProps["cWorkareaWidth"] = "cWorkareaWidth";
    CustomFabricObjectProps["cWorkareaHeight"] = "cWorkareaHeight";
    CustomFabricObjectProps["cIframeSrc"] = "cIframeSrc";
    CustomFabricObjectProps["cIframeProps"] = "cIframeProps";
    CustomFabricObjectProps["cStopProps"] = "cStopProps";
    CustomFabricObjectProps["cTableProps"] = "cTableProps";
    CustomFabricObjectProps["cWeatherProps"] = "cWeatherProps";
    CustomFabricObjectProps["cDateProps"] = "cDateProps";
    CustomFabricObjectProps["cRssFeedProps"] = "cRssFeedProps";
    CustomFabricObjectProps["cMediaCarouselProps"] = "cMediaCarouselProps";
    CustomFabricObjectProps["cSocialMediaBaseProps"] = "cSocialMediaBaseProps";
    CustomFabricObjectProps["cQRCodeProps"] = "cQRCodeProps";
    CustomFabricObjectProps["cPolygonProps"] = "cPolygonProps";
})(CustomFabricObjectProps = exports.CustomFabricObjectProps || (exports.CustomFabricObjectProps = {}));
exports.isFabricObjectOptions = (obj) => [exports.isFabricOnlyOptions, exports.isFabricWidgetOptions, exports.isFabricWorkareaOptions].some(fn => fn(obj));
exports.isFabricObjectOptionsPlayer = (obj) => [exports.isFabricOnlyOptions, exports.isFabricWidgetOptionsPlayer, exports.isFabricWorkareaOptions].some(fn => fn(obj));
exports.isFabricObjectOptionsUI = (obj) => [exports.isFabricOnlyOptions, exports.isFabricWidgetOptionsUI, exports.isFabricWorkareaOptions].some(fn => fn(obj));
exports.getCustomFabricObjectProps = () => Object.values(CustomFabricObjectProps);
exports.isTextBoxObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === 'textbox';
exports.isPathObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.path;
exports.isLineWithCustomControlsObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.lineWithCustomControls;
exports.isPolygonWithCustomControlsObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.polygonWithCustomControls;
exports.isImageObject = (item) => (item === null || item === void 0 ? void 0 : item.cType) === ObjectType.image;
exports.isVideoObject = (item) => (item === null || item === void 0 ? void 0 : item.cType) === ObjectType.video;
exports.isTriangleObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.triangle;
exports.isCircleObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.circle;
exports.isRectangleObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.rect;
exports.isIframeObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.iframe;
exports.isStopScheduleObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.stopSchedule;
exports.isRssFeedObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.rssFeed;
exports.isTableObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.table;
exports.isDateObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.date;
exports.isWeatherObject = (item) => (item === null || item === void 0 ? void 0 : item.type) === ObjectType.weather;
exports.isWorkareaObject = (item) => (item === null || item === void 0 ? void 0 : item.cType) === ObjectType.workarea;
exports.isWorkareaObjectWithImage = (item) => (item === null || item === void 0 ? void 0 : item.cType) === ObjectType.workarea && (item === null || item === void 0 ? void 0 : item.cKey) !== undefined;
exports.isPlayerVideoObject = (item) => (item === null || item === void 0 ? void 0 : item.cType) === ObjectType.video;
exports.isQRCodeObject = (item) => (item === null || item === void 0 ? void 0 : item.cType) === ObjectType.qrCode;
exports.isNormalObject = (item) => (item === null || item === void 0 ? void 0 : item.type) &&
    [
        ObjectType.circle,
        ObjectType.rect,
        ObjectType.textbox,
        ObjectType.image,
        ObjectType.triangle,
        ObjectType.polygonWithCustomControls,
        ObjectType.lineWithCustomControls,
        ObjectType.path
    ].includes(item.type);
exports.isCustomWidget = (item) => (item === null || item === void 0 ? void 0 : item.type) &&
    [
        ObjectType.date,
        ObjectType.iframe,
        ObjectType.qrCode,
        ObjectType.rssFeed,
        ObjectType.video,
        ObjectType.socialMedia,
        ObjectType.table,
        ObjectType.stopSchedule,
        ObjectType.mediaCarousel,
        ObjectType.weather
    ].includes(item.type);
//# sourceMappingURL=objects.js.map